import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import ImageUpload from "./ImageUpload"; // Should handle both image/video based on accept prop

interface ImageUploadDialogProps {
  open: boolean;
  onClose: () => void;
  onUpload: (files: File[]) => void;
  multiple?: boolean;
  uploadsubText?: string;
  heading?: string;
  accept?: string; // <-- Add this to allow video or both
}

const ImageUploadDialog: React.FC<ImageUploadDialogProps> = ({
  open,
  onClose,
  onUpload,
  multiple = true,
  uploadsubText,
  heading = "Upload Media", // <-- more generic
  accept = "image/*,video/*", // <-- allow both by default
}) => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    setLoading(true);
    onUpload(selectedFiles);
    setLoading(false);
    handleClose();
  };

  const handleClose = () => {
    setSelectedFiles([]);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{ zIndex: 2000 }}
    >
      <DialogTitle>{heading}</DialogTitle>
      <DialogContent>
        <ImageUpload
          showImagesList={true}
          existingImageList={[]}
          newImageList={selectedFiles}
          addImagesToBeUploaded={(files) => setSelectedFiles(files)}
          removeImage={(file) =>
            setSelectedFiles((prev) =>
              prev.filter((f) => f.name !== file.title)
            )
          }
          size="large"
          multiple={multiple}
          uploadText={uploadsubText}
          allowedFileTypes={accept} 
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
        {loading ? (
          <Button sx={{ display: "flex", alignItems: "center", gap: "7px" }}>
            <CircularProgress size={16} color="inherit" />
            Uploading...
          </Button>
        ) : (
          <Button onClick={handleUpload}>Upload</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ImageUploadDialog;
